import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoMapM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.78571 1C1.79949 1 1 1.79949 1 2.78571V9.21429C1 10.2005 1.79949 11 2.78571 11H9.21429C10.2005 11 11 10.2005 11 9.21429V2.78571C11 1.79949 10.2005 1 9.21429 1H2.78571ZM1.71429 2.78571C1.71429 2.19398 2.19398 1.71429 2.78571 1.71429H3.02601L1.71429 3.27754V2.78571ZM1.71429 4.38877L3.95845 1.71429H5.46254L1.71429 6.18128V4.38877ZM6.39497 1.71429H7.8991L1.71429 9.08506V7.29251L6.39497 1.71429ZM8.83154 1.71429H9.21429C9.53806 1.71429 9.82829 1.8579 10.0248 2.0849L3.14346 10.2857H2.78571C2.45495 10.2857 2.1592 10.1358 1.96266 9.90029L8.83154 1.71429ZM10.2857 2.88513V4.67769L5.58002 10.2857H4.07589L10.2857 2.88513ZM10.2857 5.78892V7.58147L8.01658 10.2857H6.51246L10.2857 5.78892ZM10.2857 8.6927V9.21429C10.2857 9.80602 9.80602 10.2857 9.21429 10.2857H8.94902L10.2857 8.6927Z"
      />
    </svg>
  )
}
export const IconGeoMap = createIcon({
  l: IconGeoMapM,
  m: IconGeoMapM,
  s: IconGeoMapM,
  xs: IconGeoMapM,
  name: 'IconGeoMap',
})
